import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.925 10 3 4.075 4.075 3 10 8.925 15.925 3 17 4.075 11.075 10 17 15.925 15.925 17 10 11.075 4.075 17 3 15.925z"
    }, null, -1)
  ])))
}
export default { render: render }